<template>
<div class="chapter">
<div class="inner_page">
<p class="C191"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="C192"><a id="page_v"></a><a href="#/xhtml/05_Acknowle#page_vi">ACKNOWLEDGMENTS</a></p>
<p class="C193"><a href="#/xhtml/06_Introduc#page_2">INTRODUCTION</a></p>
<p class="C193"><a href="#/xhtml/06_Introduc#page_2">The Sidelong World</a></p>
<p class="C193"><em><a href="#/xhtml/06_Introduc#page_2">Where Confession and Proclamation</a></em></p>
<p class="C179"><em><a href="#/xhtml/06_Introduc#page_2">Are Compounded</a></em></p>
<p class="C193">CARLOS MONSIVÁIS</p>
<p class="C179"><span href="#/xhtml/07_Pillar_o#page_46" title="Link target outside of Sample">Pillar of Salt</span></p>
<p class="C193">SALVADOR NOVO</p>
<p class="C193"><span href="#/xhtml/08__This_fl#page_151" title="Link target outside of Sample">“This flower of fourteen petals”</span></p>
<p class="C179"><span href="#/xhtml/08__This_fl#page_151" title="Link target outside of Sample"><em>Salvador Novo and the Sonnet</em></span></p>
<p class="C193">MARGUERITE FEITLOWITZ</p>
<p class="C179"><span href="#/xhtml/09_Sonnets#page_155" title="Link target outside of Sample">Sonnets</span></p>
<p class="C192">SALVADOR NOVO</p>
<p class="C193"><span href="#/xhtml/10_Notes#page_195" title="Link target outside of Sample">NOTES</span></p>
<p class="C193"><span href="#/xhtml/11_Index#page_203" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?8d4123a0